
<div class="h-100" *ngIf="(geofencesService.nameComponentPol == 'LISTAR')">
  <app-geofence-table (eventDisplayTags)="eventDisplayTags($event)"></app-geofence-table>
</div>
<div class="h-100" *ngIf="(geofencesService.nameComponentPol == 'ADD GEO')">
  <app-geocerca-add></app-geocerca-add>
</div>
<div>
  <app-add-tag (onHideEvent)="closeModal($event)" [display]="displayTags"></app-add-tag>
</div>